import { render, staticRenderFns } from "./VendorRecruiters.vue?vue&type=template&id=24418a94&"
import script from "./VendorRecruiters.vue?vue&type=script&lang=js&"
export * from "./VendorRecruiters.vue?vue&type=script&lang=js&"
import style0 from "./VendorRecruiters.vue?vue&type=style&index=0&id=24418a94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports